import { CasinoPlayerService } from './casino-player.service';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { Observable, BehaviorSubject, from } from 'rxjs';
import { SharedService } from './shared.service';
import { CurrencyService } from './currency.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ValidateLoyaltyService } from './validate-loyalty.service';
import { HttpService } from './http.service';
import { GetLocationApiResponse } from 'model/shared/backend-api-response/get-location-api-response';
import { BookDataResponse } from 'model/wbe/backend-api-response/book-data-response';

@Injectable()
export class BookService {
  propertyname: string = '';
  servername: string = '';
  errorMessage: string = '';
  observables: any = [];
  propertyname_travel: string = '';
  cartCount: number = 0;
  private offerName = new BehaviorSubject<string>('offer');
  offerchange = this.offerName.asObservable();

  constructor(
    private _http: HttpClient,
    public httpService: HttpService,
    private configservice: LegacyBookInitService,
    public validateLoyalty: ValidateLoyaltyService,
    public CasinoPlayerService: CasinoPlayerService,
    public currencyservices: CurrencyService,
    public SharedService: SharedService
  ) {
    this.propertyname = configservice.PropertyData.PropNameKeyList.book;
    this.servername = configservice.getserverDetails_book();
    this.propertyname_travel = configservice.PropertyData.PropNameKeyList.updateres;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
  changeOffer(message: string) {
    this.offerName.next(message);
  }
  putValue(
    room,
    arrival,
    departure,
    casinoNumber,
    offerCode,
    thead,
    refineSearch,
    guestCountDetail,
    guestComments,
    selectedOffer,
    tenantId,
    propertyId,
    enhanceData,
    fromUpdateRes = false
  ) {
    console.log(room);
    var offerName;
    var guestCount;
    var departureDate = new Date(departure);
    var arrivalDate = new Date(arrival);
    var timeDiff = Math.abs(departureDate.getTime() - arrivalDate.getTime());
    var daysStay = Math.ceil(timeDiff / (1000 * 3600 * 24));
    this.offerchange.subscribe((offerDescribe) => {
      offerName = offerDescribe;
    });
    let adultsValue, childValue, infantsValue, juniorValue, disablePeopleValue;
    let totalGuestCount = 0;

    if (refineSearch) {
      guestCount = guestCountDetail[0].selectedValue ? guestCountDetail[0].selectedValue : 1;
      adultsValue = guestCountDetail.findIndex((guest) => guest.key === 'adults');
      childValue = guestCountDetail.findIndex((guest) => guest.key === 'children');
      infantsValue = guestCountDetail.findIndex((guest) => guest.key === 'infants');
      juniorValue = guestCountDetail.findIndex((guest) => guest.key === 'juniors');
      disablePeopleValue = guestCountDetail.findIndex((guest) => guest.key === 'discChild');
      guestCountDetail.forEach((element) => {
        if (element.selectedValue) {
          totalGuestCount += Number(element.selectedValue);
        }
      });
    } else {
      guestCount = guestCountDetail;
    }

    let values: any = {
      id: this.cartCount++,
      hasEnhancement: room.hasEnhancement,
      roomSoldOut: room.roomSoldOut,
      room: room,
      BookingTotalWithoutEnhancement: room.quoteTotal,
      BookingTaxTotalWithoutEnhancement: room.quoteTotalTax,
      enhanceData: enhanceData,
      tenantId: tenantId,
      propertyId: propertyId,
      arrival: arrival,
      departure: departure,
      casinoNumber: casinoNumber,
      offerCode: offerCode,
      daysStay: daysStay,
      thead: thead,
      guestCount: refineSearch ? totalGuestCount : guestCount,
      adults: refineSearch ? guestCountDetail[adultsValue].selectedValue : guestCount,
      children: refineSearch
        ? guestCountDetail[childValue]
          ? guestCountDetail[childValue].selectedValue
            ? guestCountDetail[childValue].selectedValue
            : 0
          : 0
        : 0,
      infants: refineSearch
        ? guestCountDetail[infantsValue]
          ? guestCountDetail[infantsValue].selectedValue
            ? guestCountDetail[infantsValue].selectedValue
            : 0
          : 0
        : 0,
      juniors: refineSearch
        ? guestCountDetail[juniorValue]
          ? guestCountDetail[juniorValue].selectedValue
            ? guestCountDetail[juniorValue].selectedValue
            : 0
          : 0
        : 0,
      disablePeople: refineSearch
        ? guestCountDetail[disablePeopleValue]
          ? guestCountDetail[disablePeopleValue].selectedValue
            ? guestCountDetail[disablePeopleValue].selectedValue
            : 0
          : 0
        : 0,
      offerName: offerName,
      guestComments: '',
      guestDetails: [],
      offerDetails: selectedOffer,
      isCasinoOffer: selectedOffer.casinoNumberRequired,
    };

    if (fromUpdateRes) {
      values.tbody = room.tbody;
      values.thead = room.thead;
    }
    console.log(values.isCasinoOffer);
    this.CasinoPlayerService.userData$.subscribe((result) => {
      if (result != 'data') {
        let casData = JSON.parse(localStorage.getItem(tenantId + '-' + propertyId + '-' + 'Casino'));
        values.guestDetails[0] = {
          id: 0,
          title: result.title,
          empTitle: result.title == '' ? true : false,
          fName: result.firstName,
          empFName: result.firstName == '' ? true : false,
          lName: result.lastName,
          empLName: result.lastName == '' ? true : false,
          email: result.emailAddress,
          empEmail: result.emailAddress == '' ? true : false,
          mobile: result.mobilePhoneNumber,
          empMobile: result.mobilePhoneNumber == '' ? true : false,
          address: result.addressLine1 + ' ' + result.addressLine2,
          addressLine1: result.addressLine1 ? result.addressLine1 : '',
          addressLine2: result.addressLine2 ? result.addressLine2 : '',
          empAddress: result.addressLine1 + result.addressLine2 == '' ? true : false,
          city: result.cityName,
          empCity: result.cityName == '' ? true : false,
          state: result.state,
          postalCode: result.postalCode,
          empPostalCode: result.postalCode == '' ? true : false,
          country: result.countryCode,
          empCountry: result.countryCode == '' ? true : false,
          empState: result.state == '' ? true : false,
          comments: '',
          casinoNo: casData.casinoNumber,
          sameAddress: false,
          sameDetails: false,
          isCasinoPlayer: casData.casinoNumber ? true : false,
          isLoginPlayer: casData.casinoNumber ? true : false,
          isAddedPlayer: casData.casinoNumber ? false : true,
          Authorized: casData.casinoNumber ? true : false,
          casinoValidateFalse: casData.casinoNumber ? false : true,

          maskedEmail: this.mask(result.emailAddress),
          maskedMobile: this.mask(result.mobilePhoneNumber),
          maskedAddress: this.mask(result.addressLine1 + ' ' + result.addressLine2),
          maskedCity: this.mask(result.cityName),
          maskedState: this.mask(result.state),
          maskedPostalCode: this.mask(result.postalCode),
          maskedCountry: this.mask(result.countryCode),
        };
      }
    });

    this.validateLoyalty.casinoPlayerDetails.subscribe((result) => {
      if (result != 'default') {
        values.guestDetails[0] = {
          id: 0,
          title: result['title'],
          empTitle: result['title'] == '' ? true : false,
          fName: result['firstName'],
          empFName: result['firstName'] == '' ? true : false,
          lName: result['lastName'],
          empLName: result['lastName'] == '' ? true : false,
          email: result['emailAddress'],
          empEmail: result['emailAddress'] == '' ? true : false,
          mobile: result['mobilePhoneNumber'],
          empMobile: result['mobilePhoneNumber'] == '' ? true : false,
          address: result['addressLine1']
            ? result['addressLine1'] + (result['addressLine2'] ? ', ' + result['addressLine2'] : '')
            : result['addressLine2']
            ? result['addressLine2']
            : '',
          addressLine1: result['addressLine1'] ? result['addressLine1'] : '',
          addressLine2: result['addressLine2'] ? result['addressLine2'] : '',
          empAddress: result['addressLine1'] + result['addressLine2'] == '' ? true : false,
          city: result['cityName'],
          empCity: result['cityName'] == '' ? true : false,
          state: result['state'],
          postalCode: result['postalCode'],
          empPostalCode: result['postalCode'] == '' ? true : false,
          country: result['countryCode'],
          empCountry: result['countryCode'] == '' ? true : false,
          empState: result['state'] == '' ? true : false,
          comments: '',
          casinoNo: result['casinoNumber'],
          sameAddress: false,
          sameDetails: false,
          isCasinoPlayer: true,
          isLoginPlayer: false,
          isAddedPlayer: false,
          Authorized: true,
          casinoValidateFalse: false,

          maskedEmail: this.mask(result['emailAddress']),
          maskedMobile: this.mask(result['mobilePhoneNumber']),
          maskedAddress: this.mask(result['addressLine1'] + ' ' + result['addressLine2']),
          maskedCity: this.mask(result['cityName']),
          maskedState: this.mask(result['state']),
          maskedPostalCode: this.mask(result['postalCode']),
          maskedCountry: this.mask(result['countryCode']),
        };
      }
    });

    let appendArray = values;

    if (fromUpdateRes) {
      // if from updateRes just return the array
      return appendArray;
    } else {
      if (room.transition) {
        this.SharedService.updateRoomData(appendArray, 'shownet');
      } else {
        this.SharedService.updateRoomData(appendArray, 'wbe');
      }
    }
  }

  private errorHandle = (error) => {
    console.log(error);
    this.errorMessage = error.ErrorMessage;
  };

  submitBookData(data): Observable<any> {
    let urlData = [];
    this.propertyname = this.configservice.PropertyData.PropNameKeyList.book;
    if (data.length) {
      for (let u = 0; u < data.length; u++) {
        urlData[u] = {
          url:
            this.configservice.getCloudDomainName() +
            '/' +
            this.servername +
            '/tenants/' +
            data[u].tenant +
            ('/context/' + this.configservice.PropertyData.ContextId + '/') +
            'propertyName/' +
            this.propertyname +
            '?appName=wbe&locale=' +
            this.configservice.langCode +
            `&propertyId=${this.configservice?.propertyId}`,
          body: data[u].data,
        };
      }
      return from(urlData).pipe(
        concatMap((dta) => <Observable<BookDataResponse>>this.httpService.post(dta.url, dta.body, this.configservice.serviceHeaders))
      );
    } else {
      return of(null);
    }
  }

  submitMergeTravelWith(mergeData, tenantId) {
    let body = { TRAVELWITH: mergeData };
    this.propertyname_travel = this.configservice.PropertyData.PropNameKeyList.updateres;
    if (mergeData) {
      let url;
      console.log('Travel with');
      console.log(body);
      url =
        this.configservice.getCloudDomainName() +
        '/' +
        this.servername +
        '/tenants/' +
        tenantId +
        ('/context/' + this.configservice.PropertyData.ContextId + '/') +
        'propertyName/' +
        this.propertyname_travel +
        '/action/travelWith?appName=wbe';
      this.httpService
        .put(url, body, this.configservice.serviceHeaders)
        .pipe(
          tap((data) => console.log(data)),
          catchError(this.handleError('getOffers', []))
        )
        .subscribe(
          (data) => console.log(data),
          (err) => console.log(err)
        );
    }
  }

  getZipCodeDetails(zipCode: any, address: any = ''): Observable<GetLocationApiResponse> {
    // let url = this.server_name;
    let url =
      this.configservice.getCloudDomainName() +
      '/' +
      this.servername +
      '/tenants/' +
      this.configservice.tenantId +
      `/getLocation?address=${encodeURIComponent(address)}&zipCode=${zipCode}`;
    //let url = "http://10.17.38.26:8080/"  + this.servername + '/tenants/' + "1" +"/getLocation?zipCode="+zipCode;
    return this.httpService.get(url, this.configservice.serviceHeaders).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }

  mask(s) {
    let result = '';
    if (s)
      for (var i = 0; i < s.length; i++) {
        result = result + '*';
      }
    return result;
  }
}
